export const legalTranslations = {
  ru: {
    layout: {
      toc: "Оглавление",
      docs: "Документы",
      backToTop: "Наверх",
      nav: {
        terms: "Условия использования",
        privacy: "Политика конфиденциальности",
        rules: "Правила проекта",
        contacts: "Контакты и реквизиты"
      }
    },
    terms: {
      back: "Назад к документам",
      title: "Условия использования",
      updated: "Последнее обновление:",
      date: "21 августа 2026",
      copyLink: "Скопировать ссылку на раздел",
      copied: "Ссылка скопирована"
    }
  },
  en: {
    layout: {
      toc: "Table of Contents",
      docs: "Documents",
      backToTop: "Top",
      nav: {
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        rules: "Project Rules",
        contacts: "Contacts & Details"
      }
    },
    terms: {
      back: "Back to documents",
      title: "Terms of Service",
      updated: "Last updated:",
      date: "August 21, 2026",
      copyLink: "Copy link to section",
      copied: "Link copied"
    }
  }
};